import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {SortTableCellToggle} from '../../../../../shared/models/sort-table/cell-classes';
import {ToggleInputWrapperComponent} from '../../../toggle-input-wrapper/toggle-input-wrapper.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'motn-sort-table-cell-toggle',
  template: `
    <motn-toggle-input-wrapper>
      <input
        type="checkbox"
        [(ngModel)]="cell.toggled"
        (click)="onChange($event)"
        #checkboxEl
      >
    </motn-toggle-input-wrapper>
  `,
  styleUrls: ['./sort-table-cell-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ToggleInputWrapperComponent,
    FormsModule,
  ],
})
export class SortTableCellToggleComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellToggle;

  @ViewChild('checkboxEl') checkboxEl: HTMLInputElement;


  constructor() {
    super();
  }


  protected onInit() {
  }


  onChange($event) {
    $event.preventDefault();

    if (this.cell.callback) {
      this.cell.callback(!this.cell.toggled, this.checkboxEl);
    }
  }
}
